import LocalizedLink from '@components/Localization/LocalizedLink'
import { Box, OldHeading, Image, linkStyle } from '@gassan-ui'
import { cn } from '@lib/cn'
import { TourPage } from '@lib/kontent/models/TourPage'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import styled from 'styled-components'
import { GridColumnProps, gridColumn } from 'styled-system'

const StyledImage = styled(Image)`
  opacity: 1;
  transition: all 0.3s ease;
`

const Block = styled(Box)<GridColumnProps>`
  ${gridColumn};
  background-color: ${(p) => p.theme.colors.pampasLight};
  width: 100%;
  overflow: hidden;
  position: relative;

  @media (hover: hover) and (pointer: fine) {
    &:hover,
    &:focus {
      ${StyledImage} {
        opacity: 0.8;
      }
    }
  }
`

const LinkSpan = styled.span`
  ${linkStyle};
  border-bottom: 1px solid currentColor;
  color: currentColor;
`

type Props = {
  item: TourPage
  variant: 'tour' | 'arrangement'
}

const TourArrangementCard: FC<Props> = ({ item, variant }) => {
  const mobileImage = item.mobile_image.value[0]
  const desktopImage = item.desktop_image.value[0]
  const { t } = useTranslation(['global', 'navigation'])
  const as =
    variant === 'tour'
      ? `/tours/${item.url_slug.value}`
      : `/tours/${t('arrangementSubPath', { ns: 'navigation' })}/${item.url_slug.value}`
  return (
    <LocalizedLink href={as}>
      <Block title={item.title.value} as="a">
        <Box
          position="relative"
          height="100%"
          width="100%"
          borderColor="pampasLight"
          borderStyle="solid"
          borderWidth={['1rem', '2rem']}
        >
          <StyledImage
            alt={item.title.value}
            className={cn('z-0 aspect-[20/13]', 'md:aspect-[10/13]')}
            sources={[mobileImage.url, mobileImage.url, desktopImage.url]}
          />
          <Box
            position="absolute"
            color={'white'}
            left={{
              _: '1rem',
              small: '2rem',
              large: '1rem',
              xlarge: '2rem',
            }}
            top={{
              _: '1rem',
              small: '2rem',
              large: '2rem',
            }}
            width={{
              _: 'calc(100% - 2rem)',
              small: 'calc(100% - 5rem)',
              large: 'calc(100% - 2rem)',
              xlarge: 'calc(100% - 5rem)',
            }}
          >
            <OldHeading variant="h3" as="h3" color="currentColor" mb="0.5rem">
              {item.title.value}
            </OldHeading>
            <LinkSpan>{t('view', { ns: 'global' })}</LinkSpan>
          </Box>
        </Box>
      </Block>
    </LocalizedLink>
  )
}

export default TourArrangementCard
